import axios from 'axios';
import Vue from 'vue'

const instance = axios.create({
    baseURL: process.env.VUE_APP_CT_URL
})

instance.interceptors.request.use((config) => {
    const token = Vue.prototype.$keycloak.token;
    // const token = localStorage.getItem("vue-token")
    // const refreshToken = localStorage.getItem("vue-refresh-token")
    // console.log("token", token)
    // console.log("refreshToken", refreshToken)
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
}, (err) => {
    return Promise.reject(err)
})

export default instance